import strings from 'l10n'
import { Alert, Button, Dialog, DialogActions, DialogTitle, DialogContent } from '@mui/material'
import { fileSizeConverter } from 'tools/format'

export const DEFAULT_MAX_ATTACHMENT_BYTES = 22 * 1024 * 1024

type InvoiceSizeWarningProps = {
  errorDialogIsOpen: boolean
  closeErrorDialog: () => void
  maxAttachmentBytes?: number
  noaFileSize?: number
  // True only when removing the NOA would bring the upload back under the limit - not just when a NOA exists.
  noaCausedRejection?: boolean
}

const InvoiceSizeWarning = (props: InvoiceSizeWarningProps) => {
  const {
    errorDialogIsOpen,
    closeErrorDialog,
    maxAttachmentBytes = DEFAULT_MAX_ATTACHMENT_BYTES,
    noaFileSize = 0,
    noaCausedRejection = false,
  } = props

  const errorMessage =
    noaCausedRejection
      ? strings.formatString(strings.ERROR_FILE_SIZE_EXCEEDED_WITH_NOA, {
          limit: fileSizeConverter(maxAttachmentBytes),
          noaSize: fileSizeConverter(noaFileSize),
        })
      : strings.formatString(strings.ERROR_FILE_SIZE_EXCEEDED, { limit: fileSizeConverter(maxAttachmentBytes) })

  return (
    <>
      <Alert severity="warning" sx={{ marginTop: 2 }}>
        {strings.formatString(strings.INFO_MAX_FILE_SIZE, { limit: fileSizeConverter(maxAttachmentBytes) })}
      </Alert>
      <Dialog open={errorDialogIsOpen} onClose={closeErrorDialog}>
        <DialogTitle>{strings.ERROR_FILE_SIZE_EXCEEDED_TITLE}</DialogTitle>
        <DialogContent>
          <p>{errorMessage}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeErrorDialog} variant="contained" color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default InvoiceSizeWarning
